import { IPlan } from "../models/PlanModel";

export const INIT_PLAN_VALUE: IPlan = {
  id: "",
  code: "",
  name: "",
  year: "",
};

export const PLAN_STATUS = {
  OPEN: 1,
  CLOSE: 2,
};

export const PLAN_STATUS_NAME = {
  [PLAN_STATUS.OPEN]: "Mở",
  [PLAN_STATUS.CLOSE]: "Đóng",
};

export const PLAN_MODEL_JSON = {
  BUILD_PLAN: "buildPlan",
}
